const sections = [
  { label: 'Welcome', to: '/', aria: 'Welcome'},
  { label: 'Projects', to: '/projects', aria: 'Projects' },
  { label: 'Experience', to: '/experience', aria: 'Experience' },
  { label: 'Get in Touch', to: '/contact', aria: 'Contact' },
];

export default sections;
